module.exports = __webpack_public_path__ + "img/obtain_success.9550eef6.png";